import axios from 'axios'
import { Toast } from 'vant';
import Vue from 'vue'
import store from '../store'
import main from '../main'
import router from '../router'
import config from '../utils/config'
Vue.use(Toast);
// 接口公共参数
const param = {};
const ajax = p => {
  /*
  * 将初始值和传进来的值进行合并
  * */
  let c = Object.assign({
    url: '',
    type: 'get',
    params: {},
  }, p);
  /*
  * url环境设置
  * */
  c.url = config.baseServerUrl + c.url
  /*
  * 请求拦截器
  * 判断每次请求前token存在则请求头中携带token
  * */
  axios.interceptors.request.use(
    config => {

      if(localStorage.getItem('token')) {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers.auth_token = token

        }
      }
      return config
    },
    error => Promise.error(error + '')
  );
  axios.defaults.timeout = 1000 * 12;
  axios.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error && error.response) {
        switch (error.response.status) {
          case 400: error.message = '请求错误(400)'; break;
          case 401: error.message = '未授权，请重新登录(401)'; break;
          case 403: error.message = '拒绝访问(403)'; break;
          case 404: error.message = '接口请求出错(404)'; break;
          case 408: error.message = '接口请求超时(408)'; break;
          case 500: error.message = '服务器错误(500)'; break;
          case 501: error.message = '服务未实现(501)'; break;
          case 502: error.message = '网络错误(502)'; break;
          case 503: error.message = '服务不可用(503)'; break;
          case 504: error.message = '网络超时(504)'; break;
          case 505: error.message = 'HTTP版本不受支持(505)'; break;
          default: error.message = `连接出错(${error.response.status})!`;
        }
      }  else {
        error.message = '连接服务器失败!'
      }

      return Promise.reject(error)
    }

  )

  return new Promise((resolve, reject) => {
    // 将外部参数和共公参数合并
    let params, data = '';
    if (c.type === 'get') {
      params = Object.assign(c.params, param);
    } else {
      data = Object.assign(c.params, param);
    }
    // store.commit('LOADING')
    let mask = Toast.loading({
      duration: 0,
      forbidClick: true,
      mask: false,
      message: '加载中...'
    });
    axios({
      url: c.url,
      method: c.type,
      data: data,
      params: params
    }).then(res => {
      mask.clear();
      switch (res.data.code) {
        case 200:
          resolve(res.data);
          break;
        case -3:
          if(store.state.flag) {
            store.dispatch('setTip', false)
            main.$dialog.confirm({
              title: '超时提醒',
              message: '当前登陆超时，请前往登陆'
            }).then(() => {
              router.push({
                path: '/login'
              })
            }).catch(() => {
              store.dispatch('setTip', true)
            });
          }
          break;
        case -4:
          main.$dialog.confirm({
            title: '登陆提醒',
            message: '当前操作需要登陆，是否前往登陆？'
          }).then(() => {
            router.push({
              path: '/login'
            })
          }).catch(() => {

          });
          break;
          case -6:
            let second = 4;
            const timer = setInterval(() => {
              second --;
              if (second < 1) {
                clearInterval(timer);
                main.$dialog.close();
                localStorage.setItem('userInfo', '');
                localStorage.setItem('token', '');
                store.dispatch('setCarNumber', 0);
                localStorage.setItem('carList', '');
                router.push({
                  name: 'personal-center'
                })
              } else {
                main.$dialog.confirm({
                  title: '退出提醒',
                  message: '当前账户已被禁用即将退出 ' + second ,
                  showConfirmButton: false,
                  showCancelButton: false
                });
              }
            }, 1000);
          break;
          case -8:
            localStorage.setItem('userInfo', '');
            localStorage.setItem('token', '');
            store.dispatch('setCarNumber', 0);
            localStorage.setItem('carList', '');
            if(store.state.flag) {
              store.dispatch('setTip', false)
              main.$dialog.confirm({
                title: '账户提醒',
                message: '当前账号已在其他设备退出，是否重新登陆？'
              }).then(() => {
                router.push({
                  path: '/login'
                })
              }).catch(() => {
                store.dispatch('setTip', true)
              });
            }
          break;
        default:
          resolve(res.data);
          break;
      }
    }).catch(err => {
      mask.clear();
      main.$notify(err + '');
      reject(err)
    })
  })

};

export default ajax
